{
    "NavigationNext": "Avanti",
    "NavigationPrevious": "Precedente",
    "ApplicationUservoice": "https:\/\/akixi.uservoice.com",
    "ApplicationDefaultDirectory": "\/CCS\/Styles\/Images\/Akixi2019\/",
    "NAME": "LanguageGeneral"
}